<template>
  <div>
    <nav class="admin-sidebar" :class="{rail: hidden}" aria-label="Main">
        <div v-for="group in groups" :key="group.label || 'home'" class="sb-group">
            <button v-if="group.label && !hidden" type="button" class="sb-label" :aria-expanded="String(!isCollapsed(group))"
                    @click="toggle(group)">
                <span>{{ group.label }}</span>
                <i class="bi" :class="isCollapsed(group) ? 'bi-chevron-right' : 'bi-chevron-down'" aria-hidden="true"></i>
            </button>
            <div v-else-if="group.label" class="sb-divider" role="separator" :aria-label="group.label"></div>
            <!-- In the rail every entry shows: group folding would hide icons with no label to say why. -->
            <div v-show="hidden || !isCollapsed(group)">
                <el-tooltip v-for="item in group.items" :key="item.to" :content="item.label" placement="right"
                            :disabled="!hidden" :open-delay="150" effect="dark">
                    <router-link :to="item.to" class="sb-item" :class="{on: active(item)}"
                                 :aria-current="active(item) ? 'page' : null" :aria-label="hidden ? item.label : null">
                        <i class="bi sb-icon" :class="item.icon" aria-hidden="true"></i>
                        <span class="sb-text">{{ item.label }}</span>
                    </router-link>
                </el-tooltip>
            </div>
        </div>
    </nav>
    <!-- Outside the nav so it stays put while the menu narrows. -->
    <button type="button" class="sidebar-toggle" :aria-expanded="String(!hidden)"
            :aria-label="hidden ? 'Expand menu' : 'Collapse menu'" :title="hidden ? 'Expand menu' : 'Collapse menu'"
            @click="toggleHidden">
        <i class="bi" :class="hidden ? 'bi-chevron-right' : 'bi-chevron-left'" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import {visibleNav, isActive} from "./navigation";

const STORE_KEY = 'sidebar.collapsed';

export default {
    name: "SideBar",
    data() {
        let saved = null;
        try {
            saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
        } catch (e) {
            saved = null;
        }
        return {collapsed: saved && typeof saved === 'object' ? saved : {}, hidden: false};
    },
    created() {
        // Whole-menu hide is remembered per browser; small screens start hidden.
        let saved = null;
        try {
            saved = localStorage.getItem('sidebar.hidden');
        } catch (e) {
        }
        this.setHidden(saved === null ? window.innerWidth < 992 : saved === '1');
    },
    computed: {
        groups() {
            return visibleNav(this.$store.getters.userInfo || {});
        }
    },
    methods: {
        setHidden(value) {
            this.hidden = value;
            document.body.classList.toggle('sidebar-hidden', value);
        },
        toggleHidden() {
            this.setHidden(!this.hidden);
            try {
                localStorage.setItem('sidebar.hidden', this.hidden ? '1' : '0');
            } catch (e) {
            }
        },
        active(item) {
            return isActive(item.to, this.$route, item.also);
        },
        isCollapsed(group) {
            // The group holding the open page always shows.
            if (group.items.some(this.active)) return false;
            return group.label in this.collapsed ? this.collapsed[group.label] : !!group.collapsed;
        },
        toggle(group) {
            this.$set(this.collapsed, group.label, !this.isCollapsed(group));
            try {
                localStorage.setItem(STORE_KEY, JSON.stringify(this.collapsed));
            } catch (e) {
                // private mode: the choice just isn't remembered
            }
        }
    }
}
</script>
